import { Environment, ENVIRONMENTS } from './environment.types';

function isEnvironment(value: unknown): value is Environment {
  return (
    typeof value === 'string' && ENVIRONMENTS.includes(value as Environment)
  );
}

export function getCurrentEnvironment(): Environment {
  /* Если в .env файле указано жёстко какая у нас среда */
  const envVar = process.env.REACT_APP_ENVIRONMENT;

  if (isEnvironment(envVar)) {
    return envVar;
  }

  /* Проверяем hostname в первую очередь, чтобы определить окружение по домену */
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;

    if (hostname.includes('test')) {
      return 'test';
    }

    if (
      hostname.includes('eis24.me') ||
      hostname === 'my.infraxor.ru'
    ) {
      return 'production';
    }

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'development';
    }
  }

  /* Смотрим на NODE_ENV только если не удалось определить по hostname */
  const nodeEnv = process.env.NODE_ENV;

  if (['production', 'test'].includes(nodeEnv)) {
    return nodeEnv as Environment;
  }

  return 'development';
}

export function isProduction(): boolean {
  return getCurrentEnvironment() === 'production';
}

export function isDevelopment(): boolean {
  return getCurrentEnvironment() === 'development';
}

export function isTest(): boolean {
  return getCurrentEnvironment() === 'test';
}
